import DevelopmentPage from './DevelopmentPage'

export default DevelopmentPage
